import { get } from 'lodash';
import { useMediaProps } from '@zapier/responsive-utils';

import { Screen } from '@zapier/checkout/src/constants';
import { Size } from '@zapier/checkout/src/types';

export const useSize = (): Size => {
  const mediaProps = useMediaProps({
    all: {
      size: 'small',
    },
    [Screen.queries.tablet]: {
      size: 'medium',
    },
    [Screen.queries.desktop]: {
      size: 'large',
    },
  });

  return get(mediaProps, 'size');
};
